export function ConcatResult() {
  this.fValue = null;
  this.fDef = null;
}
